<img width="160" height="160" src="assets/images/warning.png" alt="warning" />
<div class="pp-bold-18">{{ dialog.data.text }}</div>
<div class="pp-form-actions">
  <button
    type="button"
    puButton
    size="m"
    uiType="secondary"
    (click)="dialogRef.close()"
    translate="limitReached.dialog.close"></button>
</div>
